import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export const EvaluationsSkeleton: React.FC = () => {
  return (
    <Stack alignItems='stretch' alignContent='center'>
      {[...Array(8)].map((_, i) => (
        <Box
          sx={{
            width: '100%',
            flex: 1,
            alignSelf: 'center',
          }}
          key={i}
        >
          <Skeleton variant='rectangular' height={230} sx={{ marginBottom: '16px' }} />
        </Box>
      ))}
    </Stack>
  );
};

export default EvaluationsSkeleton;
